import React, { useCallback, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import {
  getGroupById,
  getIdentity,
  getMyGroups,
  unsubscribeCurrentIdentityFromGroups,
} from "../../actions/api";
import { Button, Modal, Typography, Alert, Space } from "antd";
import { SignatureOutlined, UsergroupAddOutlined } from "@ant-design/icons";
import { clearMyGroups } from "../../actions";

const { Title } = Typography;

const UnsubscribeFromApplicationButton = ({
  groupForSubscription,
  warning,
  onChange,
  identity,
  getIdentity,
  getMyGroups,
  myGroups,
  clearMyGroups,
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [group, setGroup] = useState(false);
  const [isPresent, setIsPresent] = useState(false);

  useEffect(() => {
    if (!identity) getIdentity();
  }, [getIdentity, identity]);

  useEffect(() => {
    if (!myGroups || myGroups.length <= 0) getMyGroups();
  }, [getMyGroups, myGroups]);

  useEffect(() => {
    if (myGroups && myGroups.length > 0) {
      setIsPresent(myGroups.some((x) => groupForSubscription === x.id));
    }
  }, [myGroups, groupForSubscription]);

  const fetchGroup = useCallback(async () => {
    const action = await dispatch(getGroupById(groupForSubscription));
    if (action?.payload?.data) setGroup(action.payload.data);
  }, [dispatch, groupForSubscription]);

  useEffect(() => {
    fetchGroup();
  }, [fetchGroup]);

  const unsubscribe = async () => {
    setLoading(true);
    await dispatch(
      unsubscribeCurrentIdentityFromGroups([groupForSubscription]),
    );

    if (onChange) {
      await clearMyGroups();
      onChange();
    }
    setLoading(false);
    setVisible(false);
  };

  const handleCancel = () => setVisible(false);

  return (
    <>
      <Button
        type="text"
        icon={<SignatureOutlined />}
        onClick={() => setVisible(true)}
        disabled={!isPresent}
      >
        {/* {!isPresent ? "Pending" : "Unsubscribe"} */}
        Unsubscribe
      </Button>
      <Modal
        style={{ minWidth: "60%" }}
        centered
        title={"Unsubscribe from resource or application"}
        open={visible}
        onOk={unsubscribe}
        onCancel={handleCancel}
        loading={loading}
      >
        {warning && (
          <Alert
            type="warning"
            showIcon
            message="Warning"
            description={warning}
          />
        )}
        <Title level={4}>Group(s) you will unsubscribe from:</Title>
        <Space>
          <UsergroupAddOutlined />
          {group && group.groupIdentifier}
        </Space>
        <p>Note: It might take up to 15 minutes to be active and visible.</p>
      </Modal>
    </>
  );
};

UnsubscribeFromApplicationButton.propTypes = {
  groupForSubscription: PropTypes.string.isRequired,
  warning: PropTypes.string,
  onChange: PropTypes.func,
  getIdentity: PropTypes.func.isRequired,
  identity: PropTypes.object,
  getMyGroups: PropTypes.func.isRequired,
  myGroups: PropTypes.array,
  clearMyGroups: PropTypes.func.isRequired,
};

// export default UnsubscribeFromApplicationButton;
export default connect(
  (state, props) => ({
    groupForSubscription: props.groupForSubscription,
    identity: state.identity,
    myGroups: state.myGroups?.data,
  }),
  {
    getIdentity,
    getMyGroups,
    clearMyGroups,
  },
)(UnsubscribeFromApplicationButton);
